export default __webpack_public_path__ + "static/media/mexFlag.942c241a.svg";